import React from 'react';
import ToolTipWithIcon from './ToolTipWithIcon';

const DeliverablityTooltip = () => {
  return (
    <ToolTipWithIcon className="icon-container deliverability-info-wrapper">
      <div className="tooltip-wrap">
        <span className="tooltip">
          Email deliverability indicates the likelihood of the email message
          reaching the inbox.
        </span>
        <div className="deliverability-list">
          <div className="deliverability-item high">
            <span className="dot" />
            <span>95% High</span>
          </div>
          <div className="deliverability-item average">
            <span className="dot" />
            <span>85% Average</span>
          </div>
          <div className="deliverability-item low">
            <span className="dot" />
            <span>75% Low</span>
          </div>
        </div>
        <span className="sharp-point" />
      </div>
    </ToolTipWithIcon>
  );
};

export default DeliverablityTooltip;
